import axios from 'axios'
import { deviceUrl} from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
// 查询设备国标参数
export function selectDevice(id) {
    const url = deviceUrl + `/device/deviceGb28181Config/${id}`
    return axios({
      method: 'get',
      url: url,
    }).then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('设备国标参数', '查询设备国标参数', res)
      }
      return Promise.resolve(res.data)
    })
  }
// 新增设备国标参数
export function saveDevice(params) {
  const url = deviceUrl + '/device/deviceGb28181Config/add'
  return axios({
    method: 'post',
    url: url,
    data: params
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('设备国标参数', '新增设备国标参数', res)
    }
    return Promise.resolve(res.data)
  })
}
// 更新设备国标参数
export function updateDevice(params) {
  const url = deviceUrl + '/device/deviceGb28181Config/update'
  return axios({
    method: 'put',
    url: url,
    data: params
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('设备国标参数', '更新设备国标参数', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除设备国标参数
export function deleteDevice(id) {
  const url = deviceUrl + `/device/deviceGb28181Config/${id}`
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('设备国标参数', '删除设备国标参数', res)
    }
    return Promise.resolve(res.data)
  })
}
